<div class="container-fluid" style="overflow-y: auto;" xmlns="http://www.w3.org/1999/html">
    <section>
        <div class="row mb-3">
            <div class="col-6 d-flex justify-content-start align-items-center">
                <header>
                    <h1><span jhiTranslate="study-editor.header">Manage Studies</span>
						<jhi-help-link [helpKey]="HELP_MANAGE_STUDIES"></jhi-help-link>
					</h1>
                </header>
            </div>
            <div class="col-6 d-flex justify-content-end align-items-center">
                <a class="btn btn-link" [routerLink]="['/study-manager/study-search']" queryParamsHandling="merge">
					<span jhiTranslate="study-editor.return-to-manage-studies">Return to Manage Studies</span>
                </a>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-lg-12">
                <div class="d-flex justify-content-start align-items-center">
                    <div class="d-inline-flex">
                        <img alt="" src="content/images/new-nursery.png"
                             class="image-padding"/>
                        <h2 class="fbk-study-heading mb-0 ms-2">
                            <span jhiTranslate="study-editor.create-study.title">Create Study</span>
                        </h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-lg-12">
                <jhi-collapsible customClass="d-inline-flex p-2 h5 fw-bold" img="content/img/basic-details.png"
                                 heading="{{'study-editor.basic-details-section' | translate | uppercase}}">
                    <div class="card bg-white mb-3">
                        <div class="card-body">
                            <div class="row mb-3 mt-3">
                                <!-- Left Column -->
                                <div class="col-md-6">
                                    <!-- Study Name -->
                                    <div class="mb-3 row">
                                        <label class="col-sm-4 col-form-label fw-bold">
                                            {{ 'study-editor.basic-details.studyName' | translate }}
                                            <span class="text-danger">{{ 'study-editor.basic-details.required' | translate }}</span>
                                        </label>
                                        <div class="col-sm-8">
                                            <input type="text"
                                                   class="form-control"
                                                   [(ngModel)]="basicDetails.name"
                                                   maxlength="225"
                                                   data-test="study-name-input"
                                                   [disabled]="!hasAnyAuthority(CREATE_STUDIES_PERMISSIONS)" required>
                                        </div>
                                    </div>

                                    <!-- Description -->
                                    <div class="mb-3 row">
                                        <label class="col-sm-4 col-form-label fw-bold">
                                            {{ 'study-editor.basic-details.description' | translate }}
                                            <span class="text-danger">{{ 'study-editor.basic-details.required' | translate }}</span>
                                        </label>
                                        <div class="col-sm-8">
                                            <input type="text"
                                                   class="form-control"
                                                   [(ngModel)]="basicDetails.description"
                                                   maxlength="225"
                                                   data-test="study-description-input"
                                                   [disabled]="!hasAnyAuthority(CREATE_STUDIES_PERMISSIONS)" required>
                                        </div>
                                    </div>

                                    <!-- Study Type -->
                                    <div class="mb-3 row">
                                        <label class="col-sm-4 col-form-label fw-bold">
                                            {{ 'study-editor.basic-details.studyType' | translate }}
                                            <span class="text-danger">{{ 'study-editor.basic-details.required' | translate }}</span>
                                        </label>
                                        <div class="col-sm-8">
                                            <ng-select
                                                    [(ngModel)]="basicDetails.studyType"
                                                    bindValue="name"
                                                    [items]="studyTypes" required>
                                                <ng-template ng-label-tmp let-item="item">
                                                    {{item.label | translate}}
                                                </ng-template>
                                                <ng-template ng-option-tmp let-item="item">
                                                    {{item.label | translate}}
                                                </ng-template>
                                            </ng-select>
                                        </div>
                                    </div>

                                    <!-- Objective -->
                                    <div class="mb-3 row">
                                        <label class="col-sm-4 col-form-label fw-bold">
                                            {{ 'study-editor.basic-details.objective' | translate }}
                                        </label>
                                        <div class="col-sm-8">
                                            <textarea class="form-control"
                                                      rows="3"
                                                      [(ngModel)]="basicDetails.objective"
                                                      maxlength="255"
                                                      [disabled]="!hasAnyAuthority(CREATE_STUDIES_PERMISSIONS)">
                                            </textarea>
                                        </div>
                                    </div>
                                </div>

                                <!-- Right Column -->
                                <div class="col-md-6">
                                    <!-- Save in -->
                                    <div class="mb-3 row">
                                        <label class="col-sm-4 col-form-label fw-bold">
                                            {{ 'study-editor.basic-details.saveIn' | translate }}
                                            <span class="text-danger">{{ 'study-editor.basic-details.required' | translate }}</span>
                                        </label>
                                        <div class="col-sm-8">
                                            <div class="input-group">
                                                <input readonly type="text" class="form-control" style="width:30px"
                                                       placeholder="" [(ngModel)]="basicDetails.parentFolderName" (click)="changeFolderLocation()" required
                                                       data-test="save-in-input">
                                                <button class="btn btn-outline-secondary" (click)="changeFolderLocation()"
                                                        data-test="change-folder-button"
                                                        *ngIf="hasAnyAuthority(STUDY_FOLDER_ACTIONS_CHANGE_PERMISSIONS)">
                                                    {{ 'study-editor.basic-details.changeFolder' | translate }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Created by -->
                                    <div class="mb-3 row">
                                        <label class="col-sm-4 col-form-label fw-bold">
                                            {{ 'study-editor.basic-details.createdBy' | translate }}
                                            <span class="text-danger">{{ 'study-editor.basic-details.required' | translate }}</span>
                                        </label>
                                        <div class="col-sm-8">
                                           {{user?.firstName}} {{user?.lastName}}
                                        </div>
                                    </div>

                                    <!-- Creation date -->
                                    <div class="mb-3 row">
                                        <label class="col-sm-4 col-form-label fw-bold">
                                            {{ 'study-editor.basic-details.creationDate' | translate }}
                                            <span class="text-danger">{{ 'study-editor.basic-details.required' | translate }}</span>
                                        </label>
                                        <div class="col-sm-8">
                                            <div class="input-group">
                                                <input class="form-control w-50"
                                                       [placeholder]="'global.date.placeholder' | translate"
                                                       [(ngModel)]="basicDetails.startDate"
                                                       [disabled]="!hasAnyAuthority(CREATE_STUDIES_PERMISSIONS)"
                                                       ngbDatepicker [autoClose]="true" #startDate="ngbDatepicker" required
                                                       data-test="start-date-input">
                                                <button class="btn btn-outline-secondary calendar"
                                                        (click)="startDate.toggle()"
                                                        type="button" data-test="start-date-calendar-button"><i class="fa fa-calendar"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Completion date -->
                                    <div class="mb-3 row">
                                        <label class="col-sm-4 col-form-label fw-bold">
                                            {{ 'study-editor.basic-details.completionDate' | translate }}
                                        </label>
                                        <div class="col-sm-8">
                                            <div class="input-group">
                                                <input class="form-control w-50"
                                                       [placeholder]="'global.date.placeholder' | translate"
                                                       [(ngModel)]="basicDetails.endDate"
                                                       [disabled]="!hasAnyAuthority(CREATE_STUDIES_PERMISSIONS)"
                                                       ngbDatepicker [autoClose]="true" #endDate="ngbDatepicker"
                                                       data-test="end-date-input">
                                                <button class="btn btn-outline-secondary calendar"
                                                        (click)="endDate.toggle()"
                                                        type="button" data-test="end-date-calendar-button"><i class="fa fa-calendar"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col d-flex align-items-center justify-content-start">
                                    <div class="form-check">
                                        <input type="checkbox" class="form-check-input" id="useTemplate" #useTemplateElm
                                               [(ngModel)]="useTemplate" (ngModelChange)="useTemplateChanged($event)"
                                               data-test="use-template-checkbox">
                                        <label class="form-check-label" for="useTemplate" jhiTranslate="study-editor.create-study.template.use-study">Use a previously created study
                                            as a template</label>
                                    </div>
                                    <div class="input-group col-auto ms-3" style="width: 300px;">
                                        <input readonly type="text" class="form-control" style="width:30px"
                                               placeholder="" [(ngModel)]="templateStudyName"
                                               [disabled]="!useTemplateElm.checked" (click)="openTemplateDialog()"
                                               data-test="template-study-name-input">
                                        <button class="btn btn-info" (click)="openTemplateDialog()"
                                                [disabled]="!useTemplateElm.checked" data-test="choose-template-button" jhiTranslate="global.choose">Choose
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </jhi-collapsible>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col d-flex justify-content-end">
                <button class="btn btn-secondary" (click)="cancel()" data-test="cancel-button" jhiTranslate="cancel">Cancel</button>
                <button class="btn btn-info ms-2" (click)="createStudy()" [disabled]="isTemplateStudyLoading || isSaving" data-test="save-study-button"
					jhiTranslate="study-editor.create-study.save">Save Study</button>
            </div>
        </div>
        @if (templateStudyDetails) {
            <div class="row mb-3">
                <div class="col">
					<h5><span jhiTranslate="study-editor.create-study.template.review-vars">Review the variables to be copied from the template study: </span>
						<span class="fw-bold"><truncate-span [textInput]="templateStudyDetails.name" [maxLength]="100"></truncate-span></span></h5>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-6">
                    <jhi-collapsible customClass="d-inline-flex p-2 h5 fw-bold" heading="{{'study-editor.create-study.section.study-settings' | translate}}"
                                     iconClass="bms-icon bms-mgt-details">
                            <div class="card bg-white mb-3">
                                <div class="card-body custom-scroll-style" style="max-height: 400px; overflow-y: auto;">
                                    @if (displayedStudySettings && displayedStudySettings.length > 0) {
                                        @for (variable of displayedStudySettings; track variable.termId) {
                                            <div class="row mb-3 mt-3">
                                                <div class="col-md-3">
                                                    <a class="btn-link" [routerLink]="['/', { outlets: { popup: 'variable-details-popup' }}]"
                                                       [queryParams]="{ variableId: variable.termId }">{{ variable.alias || variable.name }}</a>
                                                </div>
                                                <div class="col-md-9">
                                                    {{variable.description}}
                                                </div>
                                            </div>
                                        }
                                    } @else {
                                        <div class="row mb-3 mt-3">
                                            <div class="col-md-12">
                                                {{'study.details.study-settings.no-data'| translate }}
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                    </jhi-collapsible>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-6">
                    <jhi-collapsible customClass="d-inline-flex p-2 h5 fw-bold" heading="{{'study-editor.create-study.section.environment-details' | translate}}" iconClass="bms-icon bms-mgt-details">
                            <div class="card bg-white mb-3">
                                <div class="card-body custom-scroll-style" style="max-height: 400px; overflow-y: auto;">
                                    @if (displayedEnvironmentDetails && displayedEnvironmentDetails.length > 0) {
                                        @for (variable of displayedEnvironmentDetails; track variable.termId) {
                                            <div class="row mb-3 mt-3">
                                                <div class="col-md-3">
                                                    <a class="btn-link" [routerLink]="['/', { outlets: { popup: 'variable-details-popup' }}]"
                                                       [queryParams]="{ variableId: variable.termId }">{{ variable.alias || variable.name }}</a>
                                                </div>
                                                <div class="col-md-9">
                                                    {{variable.description}}
                                                </div>
                                            </div>
                                        }
                                    } @else {
                                        <div class="row mb-3 mt-3">
                                            <div class="col-md-12">
                                                {{'study.details.environments.details.no-data'| translate }}
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                    </jhi-collapsible>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-6">
                    <jhi-collapsible customClass="d-inline-flex p-2 h5 fw-bold" heading="{{'study-editor.create-study.section.environment-conditions' | translate}}" [img]="'content/images/conditions.svg'" >

                            <div class="card bg-white mb-3">
                                <div class="card-body custom-scroll-style" style="max-height: 400px; overflow-y: auto;">
                                    @if (displayedEnvironmentConditions && displayedEnvironmentConditions.length > 0) {
                                        @for (variable of displayedEnvironmentConditions; track variable.termId) {
                                            <div class="row mb-3 mt-3">
                                                <div class="col-md-3">
                                                    <a class="btn-link" [routerLink]="['/', { outlets: { popup: 'variable-details-popup' }}]"
                                                       [queryParams]="{ variableId: variable.termId }">{{ variable.alias || variable.name }}</a>
                                                </div>
                                                <div class="col-md-9">
                                                    {{variable.description}}
                                                </div>
                                            </div>
                                        }
                                    } @else {
                                        <div class="row mb-3 mt-3">
                                            <div class="col-md-12">
                                                {{'study.details.environments.conditions.no-data' | translate }}
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>

                    </jhi-collapsible>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-6">
                    <jhi-collapsible customClass="d-inline-flex p-2 h5 fw-bold" heading="{{'study-editor.create-study.section.observation-traits' | translate}}" [img]="'content/images/baseline-traits.png'" >
                            <div class="card bg-white mb-3">
                                <div class="card-body custom-scroll-style" style="max-height: 400px; overflow-y: auto;">
                                    @if (displayedTraits && displayedTraits.length > 0) {
                                        @for (variable of displayedTraits; track variable.termId) {
                                            <div class="row mb-3 mt-3">
                                                <div class="col-md-3">
                                                    <a class="btn-link" [routerLink]="['/', { outlets: { popup: 'variable-details-popup' }}]"
                                                       [queryParams]="{ variableId: variable.termId }">{{ variable.alias || variable.name }}</a>
                                                </div>
                                                <div class="col-md-9">
                                                    {{variable.description}}
                                                </div>
                                            </div>
                                        }
                                    } @else {
                                        <div class="row mb-3 mt-3">
                                            <div class="col-md-12">
                                                {{'study.details.datasets.traits.no-data' | translate }}
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                    </jhi-collapsible>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-6">
                    <jhi-collapsible customClass="d-inline-flex p-2 h5 fw-bold" heading="{{'study-editor.create-study.section.observation-selections' | translate}}" [img]="'content/images/variates.png'" >
                        <div class="card bg-white mb-3">
                            <div class="card-body custom-scroll-style" style="max-height: 400px; overflow-y: auto;">
                                @if (displayedSelections && displayedSelections.length > 0) {
                                    @for (variable of templateStudyDetails.selections; track variable.termId) {
                                        <div class="row mb-3 mt-3">
                                            <div class="col-md-3">
                                                <a class="btn-link" [routerLink]="['/', { outlets: { popup: 'variable-details-popup' }}]"
                                                   [queryParams]="{ variableId: variable.termId }">{{ variable.alias || variable.name }}</a>
                                            </div>
                                            <div class="col-md-9">
                                                {{variable.description}}
                                            </div>
                                        </div>
                                    }
                                } @else {
                                    <div class="row mb-3 mt-3">
                                        <div class="col-md-12">
                                            {{ 'study.details.selections.no-data' | translate}}
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </jhi-collapsible>
                </div>
            </div>
        }
    </section>
</div>
